import { render as renderComponent } from "./component";
import { render as renderMarkdown } from "./markdown";
import { render as renderHTML } from "./html";
import { render as renderText } from "./text";
import { render as renderCustomComponent } from "./customComponent";
import { render as renderContextComponent } from "./contextComponent";
import { render as defaultRenderer } from "./default";
export var DEFAULT_RENDERER = 'default';
var renderers = {
    'component': renderComponent,
    'markdown': renderMarkdown,
    'html': renderHTML,
    'text': renderText,
    'customComponent': renderCustomComponent,
    'contextComponent': renderContextComponent,
    'default': defaultRenderer
};
var getRenderer = function (type) { return renderers[type] || renderers[DEFAULT_RENDERER]; };
export default getRenderer;
